import WizardScene from './WizardScene' 
export default WizardScene